export default {
  en: require('./en.json'),
  ru: require('./ru.json')
}
